export default function wordpressAJAX(url, action, data, file=false) {
  if(!file) {
  const bodyParams = new URLSearchParams({action: action});
  for (let key in data) {
    bodyParams.append(key, data[key]);
  }
  return fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Cache-Control': 'no-cache',
    },
    body: bodyParams,
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Invalid response');
      }
      return response.json();
    });
  } else {
    const formData = new FormData();
    for (let key in data) {
      formData.append(key, data[key]);
    }
    return fetch(`${url}?action=${action}`, {
      method: 'POST',
      // credentials: 'same-origin',
      // headers: {
      //   'Cache-Control': 'no-cache',
      //   'Content-Type': 'multipart/form-data',
      // },
      body: formData,
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Invalid response');
        }
        return response.json();
      });
  }
}